<!-- src/components/EventsMenu.vue -->
<template>
  <div class="events__menu">
    <p class="events__menu-title">Плейлисты</p>
    <button @click="selectAllEvents" class="events__menu-item active">Все мероприятия</button>
    <button @click="selectAccount" :class="['events__menu-item', { disabled: !isAuthorized }]">Аккаунт</button>
    <button @click="selectCustomFilter" class="events__menu-item events__menu-item--myFilter">Свой фильтр</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAuthorized: false
    }
  },
  methods: {
    selectAllEvents() {
      this.$emit('selectAllEvents');
    },
    selectAccount() {
      this.$emit('selectAccount');
    },
    selectCustomFilter() {
      this.$emit('selectCustomFilter');
    }
  },
  mounted(){
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));
    if (userInfo){
      this.isAuthorized = true;
    } else {
      this.isAuthorized = false;
    }
  }
};
</script>

